<template>
  <div
    id="modalLoading"
    key="modalGlobal"
    class="modal modal-lg fade"
    tabindex="-1"
    data-bs-keyboard="false"
    data-bs-backdrop="static"
    aria-labelledby="modalLoadingStaticBackdropLabel"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <img
            v-show="modalLoading.image === 'clock'"
            src="../../assets/images/aguardando.gif"
            alt="clock-iamge"
            class="img-wait"
          />
          <img
            v-show="modalLoading.image === 'zoom'"
            src="../../assets/images/zoom.gif"
            alt="zoom-image"
            class="img-zoom"
          />
          <img
            v-show="modalLoading.image === 'fileUpload'"
            src="../../assets/images/upload.gif"
            alt="fileUpload-image"
            class="img-wait"
          />
          <h4 v-show="modalLoading.title !== ''" class="mt-4 text-center">
            {{ modalLoading.title }}
          </h4>
          <h6 v-show="modalLoading.message !== ''" class="text-center">
            {{ modalLoading.message }}
          </h6>
          <button
            id="close"
            ref="btnClose"
            class="btn-modal"
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { mapState } from 'pinia'
  import { useModalLoading } from '@/store/Pinia/useModalLoading.store'
  import { Modal } from 'bootstrap'

  export default defineComponent({
    name: 'ModalLoading',
    data: () => ({}),
    computed: {
      ...mapState(useModalLoading, ['modalLoading']),
    },
    watch: {
      'modalLoading.isLoading': function w(current: boolean) {
        if (current) {
          this.modalOpen()
        } else {
          this.modalClose()
        }
      },
    },
    methods: {
      modalOpen() {
        const modal = new Modal('#modalLoading')
        modal.show()
      },
      modalClose() {
        const activeElement = document.activeElement as HTMLElement
        if (activeElement) {
          activeElement.blur()
        }
        const myModalEl = document.getElementById('modalLoading')
        const modal = Modal.getInstance(myModalEl || '')
        modal?.hide()
      },
    },
  })
</script>

<style lang="stylus" scoped>

  .img-wait
    max-width: 190px
    max-height 190px
  .img-zoom
    max-width: 190px
    max-height 190px

  .btn-modal
    opacity: 0

  @media screen and (max-width: 576px)
    .modal-dialog
      height: auto
      margin: 0.5rem
    .modal-content
      border-radius: 0.5rem
</style>
